interface IconXProps extends React.ComponentProps<"svg"> {}

export const IconX: React.FC<IconXProps> = (props) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.1416 2.2041H18.9855L12.7724 9.3053L20.0817 18.9684H14.3586L9.87606 13.1078L4.74703 18.9684H1.90139L8.54695 11.3729L1.53516 2.2041H7.40353L11.4553 7.56095L16.1416 2.2041ZM15.1435 17.2662H16.7193L6.54726 3.81692H4.85621L15.1435 17.2662Z"
        fill="currentColor"
      />
    </svg>
  );
};

IconX.displayName = "IconX";
